import PocketBase from "pocketbase";

console.log("Connecting to ", process.env.REACT_APP_DATABASE_URL)
export const pb = new PocketBase(process.env.REACT_APP_DATABASE_URL);